// COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
import Typeahead from 'fg-frontend/components/Typeahead';

// COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
// import PasswordToggle from 'fg-frontend/components/PasswordToggle';

// COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
import SocialShare from 'fg-frontend/components/SocialShare';

// COMMON: Komponenta, ktera zajistuje, ze se vertikalni menu zobrazi vzdy pouze v jednom radku (odeberte, pokud na hlavni navigaci nepouzivate)
// import GreedyMenu from 'fg-frontend/components/GreedyMenu';

// COMMON: Komponenta webslideru (odeberte, pokud tuto promitacku nepouzivate)
// import Webslider from 'fg-frontend/src/components/Webslider';

// COMMON: Ostylovani select inputu pomoci knihovny Select2 (odeberte, pokud ostylovani nepouzivate)
// import SelectDesign from './components/SelectDesign';

// COMMON: Napovedne popupy (odeberte, pokud v projektu nepouzivate, na eshopu napriklad na napovedy k parametrum a jako obecna knihovna pro zobrazovani napovednych textu)
// import Tooltip from './components/Tooltip';

// COMMON: Komponenta, ktera upoznuje posilat do GTM Datalayeru zaznamu na zaklade zapisu v data atributech (odeberte, pokud GTM nepouzivate, jinak vyuzito primarne v eshopu)
// import GtmHandler from './components/GtmHandler';

// COMMON: Komponenta, ktera vystreli specialni udalost v okamziku, kdy se objevi ve viewportu (pomocna komponenta pro GtmHandler, odeberte, pokud nepouzivate GTMHandler]
// import TriggerInViewport from './components/TriggerInViewport';

// COMMON: Komponenta, ktera nastavi obrazek do rezimu lazy (odeberte, pokud nepouzivate lazy obrazky)
// import LazyImage from './components/LazyImage';

// COMMON: Komponenta pro prepinani HTML tridy na danem elementu
import Toggler from './components/Toggler';

// COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
// import FGUpload from './components/FGUpload';

// COMMON: Komponenta pro osetreni informacnich boxu (odeberte, pokud nepouzivate funkcionalitu/extenzi AlertBox)
// import AlertBox from 'fg-frontend/src/components/AlertBox';

// COMMON: Zaviratelny alert (odeberte, pokud nemate nastaveno v RJ na komponente messages)
// import CloseableAlert from 'fg-frontend/src/components/CloseableAlert';

// COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
import GoogleRecaptcha from 'fg-frontend/src/components/GoogleRecaptcha';

// COMMON: Komponenta pro odpocet
// import Countdown from './components/Countdown';

// COMMON: Komponenta pro rozbaleni dalsich fotografii (TODO PDU: nahradit obecnejsi komponentou ListToggle)
import ShowMorePhotos from './components/ShowMorePhotos';

// COMMON: Komponenta pro AJAX nacteni SVG spritu
import AddSvgIconSprite from './components/AddSvgIconSprite';

// COMMON: Komponenta pro nacteni zakladniho instagram feedu
// import InstagramFeed from './components/InstagramFeed';

// COMMON: Komponenta pro zobrazení galerie
import PhotoSwipe from "./components/PhotoSwipe";

// Komponenty pouzite primarne v eshopu (odkomentujte v pripade eshopu, ale pozor obsahuje i univerzalne pouzitelne komponenty, pokud potrebujete, nebojte se pouzit - tj. presunout sem)
// import configureEshopComponents from './configureEshopComponents';

//ESHOP: Fulltextovy naseptavac (odeberte, pokud neni povolena fulltext feature)
import EshopFulltextAutocomplete from 'fg-frontend/src/components/EshopFulltextAutocomplete';


export default (props) => {
  switch (props.decorator || props.is) {
    case 'Typeahead':
      return Typeahead;
    case 'SocialShare':
      return SocialShare;
    case 'GoogleRecaptcha':
      return GoogleRecaptcha;
    case 'AddSvgIconSprite':
      return AddSvgIconSprite;
    case 'PhotoSwipe':
      return PhotoSwipe;
    case 'ShowMorePhotos':
      return ShowMorePhotos;
    case 'Toggler':
      return Toggler;
    case 'EshopFulltextAutocomplete':
	  return EshopFulltextAutocomplete;
    default:
      /* const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
        return eshopComponent;
      } else {
        console.log(`Unknown component ${props.decorator || props.is}`);
        return null;
      } */
		console.log(`Unknown component ${props.decorator || props.is}`);
  		return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js